import { OutcomeStatuses, type OutcomeStatus } from '../../types/history';
import { type HistoryOutcomeState } from '../history';

export type OutcomeId = number;

export type OutcomeState = {
  outcomeId: OutcomeId;
  code: string;
  label: string;
  oddId: number;
  betId?: number; // occures only in mymatch multichance (bet history)
  team?: 1 | 2;
  available?: boolean;
  percentDistribution?: number;
  playerId?: number;
  competitorId?: number;
  srPlayerId?: string;
  hasOccured?: boolean | null;
  isCancelled?: boolean | null;
  flag?: string;
  voidReason?: number | null;
  icon?: string;
  subOutcomes?: Array<OutcomeId>;
  hotUsers?: number;
};

export type EntitiesOutcomes = {
  [key: OutcomeId]: OutcomeState;
};

class OutcomeEntity {
  static isCodeYes = (state: OutcomeState): boolean => state?.code === 'yes';

  static getPlayerId = (state: OutcomeState, sbv: string | null): number | null => {
    const { code, srPlayerId } = state;
    let playerId = parseInt(code?.replace('sr:player:', '') || '', 10);

    if (isNaN(playerId)) {
      playerId = parseInt(srPlayerId?.replace('sr:player:', '') || '', 10);
      if (isNaN(playerId)) {
        // playerId is sometimes on sbv value for basket
        playerId = parseInt(sbv?.replace('player=sr:player:', '') || '', 10);
      }
    }
    return isNaN(playerId) ? null : playerId;
  };

  static getStatus = (state: (OutcomeState | HistoryOutcomeState) | null, isLive?: boolean): OutcomeStatus => {
    if (state) {
      if (state.isCancelled) {
        return OutcomeStatuses.CANCELLED;
      }

      if (state.hasOccured === true) {
        return OutcomeStatuses.WON;
      }
      if (state.hasOccured === false) {
        return OutcomeStatuses.LOST;
      }
    }

    if (isLive) {
      return OutcomeStatuses.LIVE;
    }

    return OutcomeStatuses.RUNNING;
  };

  static isSettled = (status: OutcomeStatus): boolean =>
    status === OutcomeStatuses.CANCELLED || status === OutcomeStatuses.WON || status === OutcomeStatuses.LOST;

  static isCodeOverUnder = (code: string): boolean =>
    code === 'over' ||
    code === 'under' ||
    code === '13' ||
    parseInt(code, 10) === 13 ||
    code === '12' ||
    parseInt(code, 10) === 12;
}

export { OutcomeEntity };
